@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";

.avatarContainer {
  display: flex;
  align-items: center;
  gap: sizes.$s4;
}

.avatarName {
  @include fontStyles.body-book;

  &.medium {
    font-size: fonts.$mid;
  }

  &.small {
    font-size: fonts.$small;
  }
}

.wrapper {
  min-height: 36px;
  min-width: 36px;
  height: 36px;
  width: 36px;
  border: 1px solid colors.$gray40;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: fonts.$base;
  font-weight: fonts.$book;
  line-height: 100%;
  color: var(--text-color);
  transition: background-color 0.2s;

  &.medium {
    min-height: 30px;
    min-width: 30px;
    height: 30px;
    width: 30px;
    font-size: fonts.$small;
    font-weight: fonts.$medium;
  }

  &.small {
    min-height: 24px;
    min-width: 24px;
    height: 24px;
    width: 24px;
    font-size: 9px;
  }

  &.pending {
    border: 2px dashed colors.$gray50;
  }

  &.clickable {
    cursor: pointer;

    &:hover {
      background-color: colors.$gray10;
    }
  }
}
